import React from 'react';
import { Box, makeStyles, createStyles } from '@material-ui/core';
import { isDark } from '../../../types/Theme';
var useStyles = makeStyles(function (theme) { return createStyles({
    label: {
        width: '45%',
        textAlign: 'right',
        paddingRight: '1rem',
        color: theme.palette.secondary.dark,
        textTransform: 'uppercase',
    },
    labelDark: {
        width: '45%',
        textAlign: 'right',
        paddingRight: '1rem',
        color: 'rgba(255,255,255,0.3)',
        textTransform: 'uppercase',
    },
    value: {
        width: '55%',
        whiteSpace: 'break-spaces',
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden',
    }
}); });
var HitInfoItem = function (_a) {
    var label = _a.label, value = _a.value, marginBottom = _a.marginBottom;
    var classes = useStyles();
    var dark = isDark();
    return (React.createElement(Box, { display: "flex", width: "100%", mb: marginBottom ? marginBottom : 1 },
        React.createElement("div", { className: dark ? classes.labelDark : classes.label }, label),
        React.createElement("div", { className: classes.value }, value ? value : '-')));
};
export default HitInfoItem;
//# sourceMappingURL=HitInfoItem.js.map